// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__RAsdB","iconWrapper":"Footer_iconWrapper__ci5Bi","icon":"Footer_icon__ctCoM","iconLink":"Footer_iconLink__naZKU"};